// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import Buefy from "buefy";
import "../node_modules/buefy/dist/buefy.css";
import store from "./vuex/store";
import axios from "axios";
// import 'buefy/lib/buefy.css'
import VueLocalStorage from "vue-localstorage";
import VueFormWizard from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import DatePicker from "vue2-datepicker";
import VeeValidate, { Validator, Field } from "vee-validate";
import es from "vee-validate/dist/locale/es";
import AirbnbStyleDatepicker from "vue-airbnb-style-datepicker";
import "vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css";
import { MonthPicker } from 'vue-month-picker'
import { MonthPickerInput } from 'vue-month-picker'
import { vfmPlugin } from 'vue-final-modal'
const datepickerOptions = {
  sundayFirst: true,
  dateLabelFormat: "dd, MMM, YYYY",
  days: [
    "Lunes",
    "Martes",
    "Miercoles",
    "Jueves",
    "Viernes",
    "Sábado",
    "Domingo"
  ],
  daysShort: ["Lun", "Mar", "Mie", "Jue", "Vie", "Sab", "Dom"],
  monthNames: [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Setiembre",
    "Octubre",
    "Noviembre",
    "Diciembre"
  ],
  colors: {
    selected: "#00a699",
    inRange: "#66e2da",
    selectedText: "#fff",
    text: "#565a5c",
    inRangeBorder: "#33dacd",
    disabled: "#fff"
  },
  texts: {
    apply: "Aceptar",
    cancel: "Cancelar",
    keyboardShortcuts: "Keyboard Shortcuts"
  }
  // ariaLabels: {
  //   chooseDate: (date) => date,
  //   chooseStartDate: (date) => `Elije ${date} como tu fecha de inicio.`,
  //   chooseEndDate: (date) => `Elije ${date} como tu fecha de fin.`,
  //   selectedDate: (date) => `Seleccionado. ${date}`,
  //   unavailableDate: (date) => `No disponible. ${date}`,
  //   previousMonth: 'Mover hacia atrás para elegir el mes anterior.',
  //   nextMonth: 'Mover adelante para elegir el mes próximo.',
  //   closeDatepicker: 'Cerrar calendario',
  //   openKeyboardShortcutsMenu: 'Open keyboard shortcuts menu.',
  //   closeKeyboardShortcutsMenu: 'Close keyboard shortcuts menu'
  // },
};
Vue.use(AirbnbStyleDatepicker, datepickerOptions);
Vue.use(MonthPicker)
Vue.use(MonthPickerInput)
// import messagesEs from './strings/validator/messages/er.js';
// import attributesEs from './strings/validator/attributes/es.js';
// import attributesEn from './strings/validator/attributes/en.js';
Validator.localize("es", es);
Vue.use(VeeValidate);

import { validadores } from "../src/helper/validadores.js";

// Vue.use(window.VueCharts)
Vue.use(VueFormWizard);
Vue.use(VueLocalStorage);
Vue.use(DatePicker);
window.axios = require("axios");
// const securityToken= 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyIkX18iOnsic3RyaWN0TW9kZSI6dHJ1ZSwic2VsZWN0ZWQiOnsicGFzc3dvcmQiOjB9LCJnZXR0ZXJzIjp7fSwid2FzUG9wdWxhdGVkIjpmYWxzZSwiYWN0aXZlUGF0aHMiOnsicGF0aHMiOnsicGFzc3dvcmQiOiJyZXF1aXJlIiwiZW1haWwiOiJpbml0IiwiaXNBZG1pbiI6ImluaXQiLCJfX3YiOiJpbml0IiwibmFtZS5maXJzdCI6ImluaXQiLCJuYW1lLmxhc3QiOiJpbml0IiwiX2lkIjoiaW5pdCJ9LCJzdGF0ZXMiOnsiaWdub3JlIjp7fSwiZGVmYXVsdCI6e30sImluaXQiOnsiX192Ijp0cnVlLCJuYW1lLmZpcnN0Ijp0cnVlLCJuYW1lLmxhc3QiOnRydWUsImlzQWRtaW4iOnRydWUsImVtYWlsIjp0cnVlLCJfaWQiOnRydWV9LCJtb2RpZnkiOnt9LCJyZXF1aXJlIjp7InBhc3N3b3JkIjp0cnVlfX0sInN0YXRlTmFtZXMiOlsicmVxdWlyZSIsIm1vZGlmeSIsImluaXQiLCJkZWZhdWx0IiwiaWdub3JlIl19LCJlbWl0dGVyIjp7ImRvbWFpbiI6bnVsbCwiX2V2ZW50cyI6e30sIl9ldmVudHNDb3VudCI6MCwiX21heExpc3RlbmVycyI6MH19LCJpc05ldyI6ZmFsc2UsIl9kb2MiOnsibmFtZSI6eyJmaXJzdCI6Ikt1cml6dSIsImxhc3QiOiJtcCJ9LCJpc0FkbWluIjpmYWxzZSwiX192IjowLCJlbWFpbCI6Imt1cml6b0BhcHAuY29tIiwiX2lkIjoiNWIxOWU3YjlhODZhMzkwMDAxMTE3MjE0In0sIl9wcmVzIjp7IiRfX29yaWdpbmFsX3NhdmUiOltudWxsLG51bGwsbnVsbF0sIiRfX29yaWdpbmFsX3ZhbGlkYXRlIjpbbnVsbF0sIiRfX29yaWdpbmFsX3JlbW92ZSI6W251bGxdfSwiX3Bvc3RzIjp7IiRfX29yaWdpbmFsX3NhdmUiOltdLCIkX19vcmlnaW5hbF92YWxpZGF0ZSI6W10sIiRfX29yaWdpbmFsX3JlbW92ZSI6W119LCJpYXQiOjE1Mjg0MjQzOTIsImV4cCI6MTUyODUxMDc5Mn0.UUB2NgxfcCPZpMnn-qzevsecerB93zP-60IBPGtRxIA'
// axios.defaults.headers.common["Security-Token"] = securityToken;

Vue.use(Buefy);
Vue.use(vfmPlugin);
Validator.extend("minDimensions", {
  getMessage: (field, args) => {
    return `La imagen debe se minimo ${args[0]}px por ${args[1]}px`;
  },
  validate: (value, args) => {
    return validadores.validate$c2(value, args);
  }
});

Vue.config.productionTip = false;
// window.axios=require('axios')
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>",
  store
});



// WEBPACK FOOTER //
// ./src/main.js